import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import React, { useCallback, useEffect, useMemo } from 'react'
import CalendarPickerRecommendations from './Recommendations/CalendarPickerRecommendations'
import { getRecommendationsTitleMobile } from './Recommendations/utils/recommendationsTitle'
import Modal from 'components/Luxkit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  checkIn?: string;
  monthIndex?: string;
  duration: number;
  offer: App.Offer;
  rooms: Array<App.Occupants>;
}

function OfferCalendarPickerRecommendationsModal({
  offer,
  checkIn,
  duration,
  monthIndex,
  rooms,
}: Props) {
  const title = useMemo(() => getRecommendationsTitleMobile({
    checkIn,
    monthIndex,
    duration,
    dayTitleTemplate: 'Available for {from} - {to}',
    monthTitleTemplate: 'Available in {month}',
    defaultTitle: 'Similar hotels',
  }), [checkIn, duration, monthIndex])

  const context = useModalElementContext()
  const dispatch = useOfferPageDispatch()

  const onBack = useCallback(() => {
    // clear selected date/month in offer state
    dispatch({ type: OfferPageActions.hideRecommendationsView })
    context.resolve()
  }, [dispatch, context])

  useEffect(() => {
    // save select date/month in offer state
    dispatch({ type: OfferPageActions.showRecommendationsView, monthIndex, checkInDay: checkIn })
  }, [dispatch, monthIndex, checkIn])

  return <Modal title={title} onBack={onBack} height="max" size="L">
    <CalendarPickerRecommendations
      offerId={offer.id}
      offerType={offer.type}
      rooms={rooms}
      seedOffer={offer}
    />
  </Modal>
}

export default withOfferPageState(
  (state) => ({
    offer: state.offer,
    duration: state.duration,
    rooms: state.rooms,
  }),
)(OfferCalendarPickerRecommendationsModal)
